import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React, { Component } from 'react';
import firebase from 'firebase';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import ReactExport from "react-data-export"
import Report from '../Reportes/repoViaje'
import Emple from '../views/empledo'
import '../Empleados_empresa/modal.css';
import Select from 'react-select';
import store from '../../store';
import { getAuth } from '../config/Paths'

const database = firebase.database();

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		transform: 'translate(-50%, -50%)',
		width: '450px',
		height: '450px',
		padding: "0px",

	}
};
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class ReporteAsignacionViajes extends Component {

	constructor(props) {

		super(props)
		this.state = {
			viajes: [],
			viajestemp: [],
			clientes: [],
			viajes: [],
			empleados: [],
			costoD: [],
			vehiculosD: [],
			empresa: [],
			fecha_actual: '',
			fecha_minima: '',
			input_disabled: 'disabled',
			isLoading: false,
			modalIsOpen: false,
			modalIsOpenC: false,
            EmpleActu: [],
            empresas: [],
            empresaSelect: '',
			btndisabled: true,
			fecha_desde: '',
			fecha_hasta: '',



			clienteR: [],
			centroR: [],
			ViajesR: [],
			empleadosR: [],
			vehiculosR: [],
			empresaR:[],
			empreUID: []

		}

		this.clientesRef = database.ref().child('Clientes').orderByChild('socio').equalTo('GudI9QD16ceP2Z2df28KVMeNI7h2');
		this.viajesRef = database.ref().child('Viaje');
		this.empleadosRef = database.ref().child('Empleados');
		this.costosRef = database.ref().child('CentroCosto');
		this.vehiculosRef = database.ref().child('Vehiculos');
		this.empresaRef = database.ref().child('Empresa');
		this.handleChangeDatePicker1 = this.handleChangeDatePicker1.bind(this);
		this.handleChangeDatePicker2 = this.handleChangeDatePicker2.bind(this);
		this.mostrarRegistrosHoy = this.mostrarRegistrosHoy.bind(this);


		let f = new Date();

		this.state.fecha_actual = f.getFullYear() + '-' + ((f.getMonth() + 1) > 10 ? f.getMonth : '0' + (f.getMonth() + 1)) + '-' + (f.getDate() > 10 ? f.getDate() : '0' + f.getDate());



	}

	componentWillMount() {
		let empreUID = firebase.auth().currentUser.uid;

		this.setState({ empreUID: 'GudI9QD16ceP2Z2df28KVMeNI7h2' })
	}


	componentDidMount() {
		let empreUID = firebase.auth().currentUser.uid;
		this.setState({ empreUID: 'GudI9QD16ceP2Z2df28KVMeNI7h2' })
		this.getEmpresas();
		var curr = new Date();
		curr.setDate(curr.getDate() + 3);
		var date = curr.toISOString().substr(0,10);
		// this.setState({ fecha_desde: date });
		// this.setState({ fecha_hasta: date });
		this.fecha1.value = date;
		this.fecha2.value = date;
		// this.callDatas();
	}
	
	componentWillUnmount() {
		this.state = {}
	}

    callDatas() {
        // this.clientesRef = database.ref().child('Clientes').orderByChild('socio').equalTo(this.state.empresaSelect);
        this.costosRef.once('value').then(this.gotCostos, this.errDataCosos);
		this.empresaRef.once('value').then(this.gotEmpresa, this.errDataEmpresa);
		this.vehiculosRef.once('value').then(this.gotVehiculos, this.errDataVehi);
		this.empleadosRef.once('value').then(this.gotDataEmpleados, this.errDataEmpleados);
		this.clientesRef.once('value').then(this.gotDataClientes, this.errDataClientes);
		this.viajesRef.once('value').then(this.gotDataViajes, this.errDataViajes);
    }
    
    getEmpresas() {
        firebase.database().ref('Empresa').on('value', data => {
            let empresas = [];
            data.forEach(element => {
                let k = element.key;
                let valores = element.val();
                let name = valores.codigo_empresa;
                empresas.push({
                    key: k,
                    nombre: name
                });
            });
            this.setState({  empresas: empresas });
        });
    }

    onChangeEmpresas(e) {
        this.setState({ empresaSelect: e.target.value });
        setTimeout(() => {
            this.callDatas();
            this.setState({ input_disabled: false });
        }, 2000);
    }

    inputClick() {
        this.fecha1.value = '';
		this.fecha2.value = '';
        this.callDatas();
    }
	 
	ocultarMenu() {
		store.dispatch({
			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	gotEmpresa = (data) => {
		let Datos = [];
		const Base = data.val();
		if (Base != null) {
			const keys = Object.keys(Base);
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				Datos.push({
					key: k,
					nombre: Base[k].codigo_empresa
				})
			}
			this.setState({ empresa: Datos });
		}
	}
	errDataEmpresa = (err) => {

		console.log(err);

	}

	gotVehiculos = (data) => {
		let Datos = [];
		const Base = data.val();
		if (Base != null) {
			const keys = Object.keys(Base);
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				Datos.push({
					key: k,
					placa: Base[k].placa,
                    tipo: Base[k].tipo_vehiculo,
                    movil: Base[k].movil,
                    fechaReserva: Base[k].fechaReserva
				})
			}
			this.setState({ vehiculosD: Datos });
		}
	}
	errDataVehi = (err) => {

		console.log(err);

	}

	gotDataClientes = (data) => {



		let newClientes = []

		if (data.val() !== null) {


			let clientesdata = data.val();
			let keys = Object.keys(clientesdata);


			for (let i = 0; i < keys.length; i++) {

				let k = keys[i];

				newClientes.push({
					key: k,
					apellido: clientesdata[k].apellido,
					nombre: clientesdata[k].nombre,
					correo: clientesdata[k].correo,
					estado: clientesdata[k].estado,
					centro: clientesdata[k].centro,
					numero_empleado: clientesdata[k].numero_empleado,
					areaDesc: clientesdata[k].areaDesc,
				})

			}
			this.setState({
				clientes: newClientes
			})
		}
	}
	errDataClientes = (err) => {

		console.log(err);

	}

	gotCostos = (data) => {
		let Datos = [];
		const Base = data.val();
		if (Base != null) {
			const keys = Object.keys(Base);
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				Datos.push({
					key: k,
					codigo: Base[k].codigo,
					descripcion: Base[k].descripcion,
					responsable: Base[k].responsable,
					area: Base[k].area
				})
			}
			this.setState({ costoD: Datos });
		}
	}
	errDataCosos = (err) => {

		console.log(err);

	}


	gotDataViajes = (data) => {



		let newViajes = []

		if (data.val() !== null) {

			let dataViajes = data.val();
			let keys = Object.keys(dataViajes);


			for (let i = 0; i < keys.length; i++) {
                
				let k = keys[i]

				let ingresar = false;
				let cliente;
				let empleado;
				let centro;
				let encargado;
				let vehiculo;
				let nemple;
				let tipoV;
				let foto;
				let areaDesc;
                let keyEmpleado;
                let correlativo;

				for (let j = 0; j < this.state.clientes.length; j++) {

					if (dataViajes[k].cliente === this.state.clientes[j].key) {

						cliente = this.state.clientes[j].nombre + ' ' + this.state.clientes[j].apellido;
						areaDesc = this.state.clientes[j].areaDesc;
						nemple = this.state.clientes[j].numero_empleado + '' + '';

						for (let r = 0; r < this.state.costoD.length; r++) {

							if (this.state.clientes[j].centro + '' + '' === this.state.costoD[r].key) {

								centro = this.state.costoD[r].codigo + '-' + this.state.costoD[r].area;
								encargado = this.state.costoD[r].responsable + '' + '';
							}

						}
						ingresar = true;
					}

                }

				if (dataViajes[k].fechaBajada !== undefined && ingresar) {

					for (let h = 0; h < this.state.empleados.length; h++) {

						if (dataViajes[k].empleado === this.state.empleados[h].key) {

							empleado = this.state.empleados[h].nombre;
							tipoV = this.state.empleados[h].tipo_vehiculo;
							foto = this.state.empleados[h].foto;
							keyEmpleado = this.state.empleados[h].key;


							for (let r = 0; r < this.state.vehiculosD.length; r++) {


								if (this.state.empleados[h].vehiculo === this.state.vehiculosD[r].key) {
                                    vehiculo = this.state.vehiculosD[r].placa;
                                    let fechaaa = new Date(dataViajes[k].fechaReserva).toLocaleDateString();
                                    correlativo = fechaaa.substr(0,2) + fechaaa.substr(3,2) + fechaaa.substr(8,2) + new Date(dataViajes[k].fechaReserva).getHours() + new Date(dataViajes[k].fechaReserva).getMinutes();
                                    correlativo += " "+this.state.vehiculosD[r].movil;
								}
							}

						}

					}
					if (dataViajes[k].bajarCliente === true) {
						let texto = String(dataViajes[k].lugar);
						let valor = texto.replace("San Salvador,", "")
						valor = valor.replace("de El Salvador", "")
						valor = valor.replace("El Salvador", "")
						valor = valor.replace("Centro Comercial", "")
						valor = valor.replace(",", "")

						let texto2 = String(dataViajes[k].partida);
						let valor2 = texto2.replace("San Salvador,", "")
						valor2 = valor2.replace("de El Salvador", "")
						valor2 = valor2.replace("El Salvador", "")
						valor2 = valor2.replace("Centro Comercial", "")
						valor2 = valor2.replace(",", "")
						newViajes.push({
							key: k,
							cliente: cliente,
							empleado: empleado,
							fechaReserva: dataViajes[k].fechaReserva,
							fechaBajada: dataViajes[k].fechaBajada.substring(0, 10),
							fechaSubida: dataViajes[k].fechaSubida.substring(0, 10),
							horaSubida: dataViajes[k].fechaSubida.substring(11, 16),
							horaBajada: dataViajes[k].fechaBajada.substring(11, 16),
							pago: dataViajes[k].pago,
							total: dataViajes[k].total,
							lugar: dataViajes[k].lugar,
							centro: centro,
							responsable: encargado,
							vehiculo: vehiculo,
							numero_empleado: nemple,
							numero: 1,
							personas: cliente,
							lugar: valor,
							desde: valor2,
							combinacion: valor2 + '-' + valor,
							tipoV,
							foto,
							keyEmpleado,
							detaCate: '#N/A',
							cantTrayec: 1,
                            areaDesc,
                            correlativo: correlativo
						})
					}

				}

			}
			this.setState({
				viajes: newViajes,
				viajestemp: newViajes

			})
		}

	}
	errDataViajes = (err) => {

		console.log(err);

	}

	gotDataEmpleados = (data) => {



		let newEmpleados = []

		if (data.val() !== null) {

			let dataEmpleados = data.val();
			let keys = Object.keys(dataEmpleados);


			for (let i = 0; i < keys.length; i++) {

				let k = keys[i]

				newEmpleados.push({
					key: k,
					estado: dataEmpleados[k].estado,
					nombre: dataEmpleados[k].nombre,
					vehiculo: dataEmpleados[k].vehiculo,
					socio: dataEmpleados[k].socio,
					tipo_vehiculo: dataEmpleados[k].tipo_vehiculo,
					foto: dataEmpleados[k].foto,

				})

			}
			this.setState({ empleados: newEmpleados })
		}

	}
	errDataEmpleados = (err) => {

		console.log(err);

	}


	handleChangeDatePicker1(e) {


		let fecha1 = this.fecha1.value;

		this.fecha2.value = '';


		this.setState({ fecha_hasta: '' });

		this.setState({

			fecha_minima: fecha1,
			input_disabled: ''
		})

	}


	handleChangeDatePicker2() {
		let fecha1 = this.fecha1.value;
		let fecha2 = this.fecha2.value;


		let f1 = new Date(fecha1);
		let f2 = new Date(fecha2);


		let newViajes = []

		this.state.viajes = this.state.viajestemp;
		this.setState({

			viajes: this.state.viajestemp
		})

		this.callDatas();
		setTimeout(() => {
			for (let i = 0; i < this.state.viajes.length; i++) {

				if (f1.getTime() <= (new Date(this.state.viajes[i].fechaBajada)).getTime() && f2.getTime() >= (new Date(this.state.viajes[i].fechaBajada)) || f1.getTime() <= (new Date(this.state.viajes[i].fechaSubida)).getTime() && f2.getTime() >= (new Date(this.state.viajes[i].fechaSubida))) {
					newViajes.push({
						key: this.state.viajes[i].key,
						cliente: this.state.viajes[i].cliente,
						empleado: this.state.viajes[i].empleado,
						fechaReserva: this.state.viajes[i].fechaReserva,
						fechaBajada: this.state.viajes[i].fechaBajada,
						fechaSubida: this.state.viajes[i].fechaSubida,
						horaSubida: this.state.viajes[i].horaSubida,
						horaBajada: this.state.viajes[i].horaBajada,
						pago: this.state.viajes[i].pago,
						total: this.state.viajes[i].total,
						lugar: this.state.viajes[i].lugar,
						centro: this.state.viajes[i].centro,
						responsable: this.state.viajes[i].responsable,
						vehiculo: this.state.viajes[i].vehiculo,
						numero_empleado: this.state.viajes[i].numero_empleado,
						numero: 1,
						personas: this.state.viajes[i].cliente,
						desde: this.state.viajes[i].desde,
						tipoV: this.state.viajes[i].tipoV,
						foto: this.state.viajes[i].foto,
						keyEmpleado: this.state.viajes[i].keyEmpleado,
						combinacion: this.state.viajes[i].combinacion,
						detaCate: '#N/A',
						cantTrayec: 1,
                        areaDesc: this.state.viajes[i].areaDesc,
                        correlativo: this.state.viajes[i].correlativo
					})
	
				}
	
			}
			this.setState({
				viajes: newViajes,
				btndisabled: false
			});
		}, 3000);
	}



	mostrarRegistrosHoy() {



		let f1 = new Date(this.state.fecha_actual);
		let f2 = new Date(this.state.fecha_actual);


		let newViajes = []

		this.state.viajes = this.state.viajestemp;
		this.setState({

			viajes: this.state.viajestemp
		})


		for (let i = 0; i < this.state.viajes.length; i++) {


			if (f1.getTime() <= (new Date(this.state.viajes[i].fechaBajada)).getTime() && f2.getTime() >= (new Date(this.state.viajes[i].fechaBajada)) || f1.getTime() <= (new Date(this.state.viajes[i].fechaSubida)).getTime() && f2.getTime() >= (new Date(this.state.viajes[i].fechaSubida))) {

				newViajes.push({
					key: this.state.viajes[i].key,
					cliente: this.state.viajes[i].cliente,
					empleado: this.state.viajes[i].empleado,
					fechaReserva: this.state.viajes[i].fechaReserva,
					fechaBajada: this.state.viajes[i].fechaBajada,
					fechaSubida: this.state.viajes[i].fechaSubida,
					horaSubida: this.state.viajes[i].horaSubida,
					horaBajada: this.state.viajes[i].horaBajada,
					pago: this.state.viajes[i].pago,
					total: this.state.viajes[i].total,
					lugar: this.state.viajes[i].lugar,
					centro: this.state.viajes[i].centro,
					responsable: this.state.viajes[i].encargado,
					vehiculo: this.state.viajes[i].vehiculo,
					numero_empleado: this.state.viajes[i].nemple,
					numero: 1,
					personas: this.state.viajes[i].cliente,
					desde: this.state.viajes[i].partida,
					tipoV: this.state.viajes[i].tipoV,
					foto: this.state.viajes[i].foto,
					keyEmpleado: this.state.viajes[i].keyEmpleado,
					combinacion: this.state.viajes[i].partida + '-' + this.state.viajes[i].lugar,
					detaCate: '#N/A',
					cantTrayec: 1,
					areaDesc: this.state.viajes[i].areaDesc
				})

			}

		}
		this.setState({

			viajes: newViajes

		})


	}

	mostrar = (row) => {
		this.setState({ datosAct: row, modalIsOpen: true });
	}
	mostrar2 = (row) => {
		database.ref('/Empleados/' + row.keyEmpleado).once('value').then(snap => {
			let datos = snap.val();
			datos.placa = row.vehiculo;
			datos.tipoV = row.tipoV;
			database.ref('/Socios/' + datos.socio).once('value').then(snap2 => {
				let valor = snap2.val();
				datos.nombresocio = valor.Nombre + ' ' + valor.Apellido;
				this.setState({ EmpleActu: datos });
			})

		})
		this.setState({ modalIsOpenC: true });
	}

	closeModal = () => {
		this.setState({ modalIsOpen: false })
	}
	closeModal2 = () => {
		this.setState({ modalIsOpenC: false })
	}

	generateBtnRecibo(cell, row) {
		return <button className="btn btn-success btn-sm" onClick={() => { this.mostrar(row) }} >Ver</button>;
	}

	generateVerEmple = (cell, row) => {
		return <button className="btn btn-success btn-sm" onClick={() => { this.mostrar2(row) }} >Conductor</button>;
	}


	render() {
		return (
			<div onClick={this.ocultarMenu}>
				<div className="">
					<div className="container">
						<div className="row">
                            <button disabled={this.state.btndisabled} onClick={this.inputClick.bind(this)} className="btn btn-success btn-sm " ><span className="glyphicon glyphicon-download-alt"></span> Cargar todos los registros </button>
							
							<div className="col-md-6 col-sm-6 col-xs-6">
								<ExcelFile filename="Reporte_Viajes.xlsx" element={(<button className="btn btn-success btn-sm excel"><span className="glyphicon glyphicon-download-alt"></span> Descargar Excel </button>)}>

									<ExcelSheet data={this.state.viajes} name="Viajes">
										<ExcelColumn label="Conductor" value="empleado" />
										<ExcelColumn label="Centro de costos" value="centro" />
										<ExcelColumn label="Area de descargue" value="areaDesc" />
										<ExcelColumn label="Responsable de centro de costos" value="responsable" />
										<ExcelColumn label="Unidad" value="vehiculo" />
										<ExcelColumn label="Cantidad de personas por viaje" value="numero" />
										<ExcelColumn label="Nombres (pasajeros)" value="personas" />
										<ExcelColumn label="Fecha subida" value="fechaSubida" />
										<ExcelColumn label="Hora subida" value="horaSubida" />
										<ExcelColumn label="Fecha Bajada" value="fechaBajada" />
										<ExcelColumn label="Hora Bajada" value="horaBajada" />
										<ExcelColumn label="Pago" value="pago" />
										<ExcelColumn label="Desde" value="desde" />
										<ExcelColumn label="Hacia" value="lugar" />
										<ExcelColumn label="Combinacion de rutas" value="combinacion" />
										<ExcelColumn label="Tarifa aplicada" value="tipoV" />
										<ExcelColumn label="Cantidad de trayectos" value="cantTrayec" />
										<ExcelColumn label="Precio aplicado" value="total" />
										<ExcelColumn label="Persona que solicita el servicio" value="cliente" />
										<ExcelColumn label="Codigo de empleado" value="numero_empleado" />
									</ExcelSheet>

								</ExcelFile>

							</div>
						</div>
						<br />
						<div className="row">
							<div className="col-md-4 col-xs-6 col-sm-6">
                                <div className="form-group">
                                    <label htmlFor="estado">Empresa</label>
                                    <select className="form-control" onChange={this.onChangeEmpresas.bind(this)} value={this.state.empresaSelect} >
                                    {this.state.empresas.map((snap, index) => {
                                        return (
                                            <option key={index} value={snap.key}>{snap.nombre}</option>
                                        )
                                    })}
                                    </select>
                                </div>
                            </div>
							<div className="col-md-4 col-xs-6 col-sm-6">
								<div className=" col-md-6">
									<label>Fecha inicio</label>
									<input type="date" className="form-control" max={this.state.fecha_actual} onChange={this.handleChangeDatePicker1}
										ref={input => { this.fecha1 = input; }}
									/>
								</div>
							</div>

							<div className="col-md-4 col-xs-6 col-sm-6">
								<div className="col-md-6">
									<label>Fecha fin</label>
									<input type="date" className="form-control" max={this.state.fecha_actual} onChange={this.handleChangeDatePicker2}
										ref={input => { this.fecha2 = input; }} min={this.state.fecha_minima}
									/>
								</div>
							</div>

						</div>
					</div>
					<br />



					<div className="container">

						<BootstrapTable data={this.state.viajes}
							printToolBar={true}
							ref='table'
							pagination={true}
						>
							<TableHeaderColumn width={'150'} dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							<TableHeaderColumn width={'250'} dataField='correlativo' dataSort={true} dataAlign='center'>Correlativo</TableHeaderColumn>
                            <TableHeaderColumn width={'250'} dataField='empleado' dataSort={true}>Conductor</TableHeaderColumn>
							<TableHeaderColumn width={'255'} dataField='centro' dataSort={true}>Centro de costos</TableHeaderColumn>
							<TableHeaderColumn width={'255'} dataField='areaDesc' dataSort={true}>Area de descargue</TableHeaderColumn>
							<TableHeaderColumn width={'300'} dataField='responsable' dataSort={true}>Responsable de centro de costos</TableHeaderColumn>
							<TableHeaderColumn width={'120'} dataField='vehiculo' dataSort={true}>Unidad</TableHeaderColumn>
							<TableHeaderColumn tdStyle={{textAlign: 'center'}} width={'275'} dataField='numero' dataSort={true}>Cantidad de personas por viaje</TableHeaderColumn>
							<TableHeaderColumn width={'250'} dataField='personas' dataSort={true}>Nombres (pasajeros)</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='fechaSubida' dataAlign='center' dataSort={true}>Fecha Subida</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='horaSubida' dataAlign='center' dataSort={true}>Hora subida</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='fechaBajada' dataAlign='center' dataSort={true}>Fecha Bajada</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='horaBajada' dataAlign='center' dataSort={true}>Hora bajada</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='pago' dataAlign='center' dataSort={true}>Pago</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='desde' dataAlign='center' dataSort={true}>Desde</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='lugar' dataAlign='center' dataSort={true}>Hacia</TableHeaderColumn>
							<TableHeaderColumn width={'550'} dataField='combinacion' dataSort={true}>Combinacion de rutas</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='tipoV' dataAlign='center' dataSort={true}>Tarifa aplicada</TableHeaderColumn>
							<TableHeaderColumn width={'200'} dataField='cantTrayec' dataAlign='center' dataSort={true}>Cantidad de trayectos</TableHeaderColumn>
							<TableHeaderColumn width={'150'} dataField='total' dataAlign='center' dataSort={true}>Precio aplicado</TableHeaderColumn>
							<TableHeaderColumn width={'250'} dataField='cliente' dataAlign='center' dataSort={true}>Persona que solicita el servicio</TableHeaderColumn>
							<TableHeaderColumn width={'180'} dataField='numero_empleado' dataAlign='center' dataSort={true}>Codigo empleado</TableHeaderColumn>
						</BootstrapTable>
					</div>

				</div>

			</div>
		);

	}


}
export default ReporteAsignacionViajes;
// import React, { Component } from 'react';
// import firebase from 'firebase';
// import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// import {Link} from 'react-router-dom';
// import store from '../../store';
// import ReactExport from "react-data-export";

// //https://securedeveloper.github.io/react-data-export/
// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

// const database = firebase.database();

// class ReporteAsignacionViajes extends Component {

//     constructor(props) {
//         super(props);
//         this.state = {
//             data: [],
//             dataTemp: [],
//             asignacionesV: [],
//             empleados: [],
//             vehiculos: [],
//             programaciones: [],
//             bases: [],
//             tipoV: [],
//             esperar: [],
//             labels:['Conductor','Unidad','Pasajeros','Velocidad','Rutas','Placa','Hora inicio','Hora finaliza']
//         }
//         this.empleadosRef = database.ref().child('Empleados');
//         this.vehiculosRef = database.ref().child('Vehiculos');
//         this.asignarRef = database.ref().child("AsignacionViajes");
//         this.prograRef = database.ref().child("Programacion");
//         this.baseRef    = database.ref().child("Bases");

// 		this.changeStatePrint=this.changeStatePrint.bind(this);
// 		this.handleClickPrint=this.handleClickPrint.bind(this);
//     }

//     componentWillMount() {
//         this.asignarRef.on('value', this.gotDataAsignacionViajes, this.errorDataAsignaciones);
//         database.ref('Tipos_Vehiculos').once('value').then(snap => {
//             let tipoV = [];
//             snap.forEach(element => {
//                 let data = element.val();
//                 tipoV.push(data);
//             });
//             this.setState({ tipoV })
//         });
//     }

//     componentDidMount() {
//         this.asignarRef.on('value', this.gotDataAsignacionViajes, this.errorDataAsignaciones);
//         database.ref('Tipos_Vehiculos').once('value').then(snap => {
//             let tipoV = [];
//             snap.forEach(element => {
//                 let data = element.val();
//                 tipoV.push(data);
//             });
//             this.setState({ tipoV })
//         });
//     }

//     componentWillUnmount() {
//         this.state = {

//         }
//     }

//     gotDataAsignacionViajes = (data) => {
//         let newAsignaciones = [];
//         if (data.val() !== null) {
//             let asignacionViaje = data.val();
//             let keys = Object.keys(asignacionViaje);

//             for (let i = 0; i < keys.length; i++) {
//                 let k = keys[i];
//                 if (asignacionViaje[k].tipoViaje !== undefined) {
//                     newAsignaciones.push({
//                         conduc: asignacionViaje[k].conduc,
//                         emple: asignacionViaje[k].emple,
//                         movil: asignacionViaje[k].movil,
//                         tipoVe: asignacionViaje[k].tipoVe,
//                         tipoviaje: asignacionViaje[k].tipoViaje
//                     });
//                 }
//             }
//             this.setState({ asignacionesV: newAsignaciones });
//             this.empleadosRef.on('value', this.gotDataEmpleados, this.errorDataEmpleados);
//         }
//     }

//     gotDataEmpleados = (data) => {
//         let newEmpleados = [];
//         if (data.val() !== null) {
//             let empleado = data.val();
//             let keys = Object.keys(empleado);

//             for (let i = 0; i < keys.length; i++) {
//                 let k  = keys[i];
//                 if (empleado[k].nombre !== undefined) {
//                     newEmpleados.push({
//                         key: k,
//                         nombre: empleado[k].nombre,
//                         estado: empleado[k].estado
//                     });
//                 }
//             }
//             this.setState({ empleados: newEmpleados });
//             this.vehiculosRef.on('value', this.getDataVehiculos, this.errorData);
//         }
//     }

//     getDataVehiculos = (data) => {
//         let newVehiculos = [];
//         if (data.val() !== null) {
//             let vehiculo = data.val();
//             let keys = Object.keys(vehiculo);
//             for (let i = 0; i < keys.length; i++) {
//                 let k = keys[i];
//                 if (vehiculo[k].marca !== undefined) {
//                     newVehiculos.push({
//                         key: k,
//                         marca: vehiculo[k].marca,
//                         placa: vehiculo[k].placa,
//                         movil: vehiculo[k].movil
//                     })
//                 }
//             }
//             this.setState({ vehiculos: newVehiculos });
//             this.asignarRef.on('value', this.getData, this.errorData);
//             this.prograRef.on('value', this.getDataProgramacion, this.errorData);
//         }
        
//     }

//     getDataProgramacion = (data) => {
//         let NewProgramacion = [];
//         if (data.val() !== null) {
//             let programacion = data.val();
//             let keys = Object.keys(programacion);
//             for (let p = 0; p < keys.length; p++) {
//                 let k = keys[p];
//                 if (programacion[k].destino !== undefined) {
//                     NewProgramacion.push({
//                         key: k,
//                         inicio: programacion[k].inicio,
//                         destino: programacion[k].destino
//                     })
//                 }
//             }
//             this.setState({ programaciones: NewProgramacion });
//             this.baseRef.on('value', this.getDataBases, this.errorData);
//         }
//     }

//     getDataBases = (data) => {
//         let newBases = [];
//         if (data.val() !== null) {
//             let base = data.val();
//             let keys = Object.keys(base);
//             for (let b = 0; b < keys.length; b++) {
//                 let k = keys[b];
//                 if (base[k].Nombre !== undefined) {
//                     newBases.push({
//                         key: k,
//                         nombre: base[k].Nombre
//                     });
//                 }
//             }
//             this.setState({ bases: newBases });
//             this.asignarRef.on('value', this.getData, this.errorData);
//         }
//     }

//     getData = (data) => {
//         let newAsignaciones = [];
//         let wait = [];
//         if (data.val() !== null) {
//             let data_show = data.val();
            
//             let keys = Object.keys(data_show);

//             for (let i = 0; i < keys.length; i++) {
//                 let k = keys[i];
//                 let contando = 0;
//                 if (data_show[k].velocidad !== undefined) {
//                     if (data_show[k].emple) {
//                         contando = 0;
//                         let q = Object.keys(data_show[k].emple);
//                         for (let p = 0; p < q.length; p++) {
//                             contando++;
//                         }
//                     }
//                     let conductor;
//                     let vehiculo;
//                     let ruta;
//                     let movil;
//                     let velocidad = ( data_show[k].velocidad !== undefined) ? data_show[k].velocidad : 0;
//                     let tipoVeh = data_show[k].tipoVe;
//                     let tipoVia = data_show[k].tipoviaje;

//                     let h_i = new Date(data_show[k].horaIni).getHours();
//                     let m_i = new Date(data_show[k].horaIni).getMinutes();

//                     let h_f = new Date(data_show[k].horaFin).getHours();
//                     let m_f = new Date(data_show[k].horaFin).getMinutes();

//                     h_i = (h_i < 10) ? '0' + h_i : h_i;
//                     m_i = (m_i < 10) ? '0' + m_i : m_i;

//                     h_f = (h_f < 10) ? '0' + h_f : h_f;
//                     m_f = (m_f < 10) ? '0' + m_f : m_f;

//                     let hora_i = (isNaN(h_i) || isNaN(m_i)) ? " " : h_i + ':' + m_i;
//                     let hora_f = (isNaN(h_f) || isNaN(m_f)) ? " ": h_f + ':' + m_f;
//                     if (this.state.empleados) {
//                         for (let c = 0; c < this.state.empleados.length; c++) {
//                             if (this.state.empleados[c].key !== undefined) {
//                                 if (data_show[k].conduc === this.state.empleados[c].key) {
//                                     conductor = this.state.empleados[c].nombre;
//                                 }
//                             }
//                         }
//                     }
//                     if (this.state.vehiculos) {
//                         for (let v = 0; v < this.state.vehiculos.length; v++) {
//                             if (this.state.vehiculos[v].key !== undefined) {
//                                 if (data_show[k].movil === this.state.vehiculos[v].movil) {
//                                     vehiculo = this.state.vehiculos[v].placa;
//                                     movil = this.state.vehiculos[v].movil;
//                                 }
//                             }
//                         }
//                     }

//                     if (this.state.programaciones) {
//                         for (let p = 0; p < this.state.programaciones.length; p++) {
//                             if (this.state.programaciones[p].key !== undefined) {
//                                 if (data_show[k].prograP === this.state.programaciones[p].key) {
//                                     let partida = [];
//                                     let salida = [];
    
//                                     var test_u = database.ref('Bases/'+this.state.programaciones[p].inicio);
//                                     test_u.on('child_added', function(data) {
//                                         partida.push(data.val());
//                                     });
    
//                                     var test_d = database.ref('Bases/'+this.state.programaciones[p].destino);
//                                     test_d.on('child_added', function(data) {
//                                         salida.push(data.val());
//                                     });
//                                     ruta = partida[1] + ' - ' + salida[1];
                                    
//                                 }
//                             }
//                         }
//                     }

//                     wait.push({
//                         ruta
//                     });

//                     newAsignaciones.push({
//                         key: k,
//                         nombre_conductor: conductor,
//                         unidad: movil,
//                         cant_pasajeros: contando,
//                         velocidad: velocidad,
//                         placa: vehiculo,
//                         tipoVehiculo: tipoVeh,
//                         tipoVijae: tipoVia,
//                         ruta: ruta,
//                         hora_i: hora_i,
//                         hora_f: hora_f
//                     });
//                 }
//             }
            
//             this.setState({ 
//                 data: newAsignaciones,
//                 dataTemp: newAsignaciones,
//                 esperar: wait
//             });
//         }
//     }
    
//     filterData() {
//         let newAsignaciones = [];

//         let tipoVehiculo = this.type.value.toLowerCase();
        
//         this.state.data = this.state.dataTemp;
//         if (tipoVehiculo != 0) {
//             for (let i = 0; i < this.state.data.length; i++) {
//                 let name_tipov = this.state.data[i].tipoVehiculo.toLowerCase().search(tipoVehiculo) >= 0 ? true : false;
    
//                 if (name_tipov) {
//                     newAsignaciones.push({
//                         key: this.state.data[i].key,
//                         nombre_conductor: this.state.data[i].nombre_conductor,
//                         unidad: this.state.data[i].unidad,
//                         cant_pasajeros: this.state.data[i].cant_pasajeros,
//                         velocidad: this.state.data[i].velocidad,
//                         placa: this.state.data[i].placa,
//                         tipoVehiculo: this.state.data[i].tipoVehiculo,
//                         tipoVijae: this.state.data[i].tipoVijae,
//                         ruta: this.state.data[i].ruta,
//                         hora_i: this.state.data[i].hora_i,
//                         hora_f: this.state.data[i].hora_f
//                     });
//                 }
//             }
//             this.state.data = newAsignaciones;
//             this.setState({ data : newAsignaciones });
//         } else {
//             this.setState({ data: this.state.dataTemp });
//         }
//     }

//     handleClickPrint(){
//         this.changeStatePrint();
// 	}
	
// 	changeStatePrint(){	
// 		store.dispatch({
// 			type: "STATE_REPORT",
// 			labels_report:this.state.labels,
// 			data_report:this.state.data,
// 			tipo_reporte:'reporte_new'
// 		});		
// 	}

//     errorDataAsignaciones = (error) => {
//         console.log(error);
//     }

//     errorDataEmpleados = (error) => {
//         console.log(error);
//     }

//     errorData = (error) => {
//         console.log(error);
//     }

//     render() {
//         return(
//             <div className="reporte_new">
//                 <div className="container">
//                     <div className="row">
//                     <div className="col-lg-12">
//                         <form>
//                             <div className="form-row align-items-center">
//                                     <div className="col-lg-6 col-sm-6 col-md-6">
//                                         <Link to="template" className="btn btn-success" onClick={this.filterData.bind(this)}><span class="glyphicon glyphicon-print"> Imprimir</span></Link>
//                                         <ExcelFile element={<button style={{marginLeft: 10}} className="btn btn-success">Exportar Excel</button>}>
//                                             <ExcelSheet data={this.state.data} name="Tes">									
//                                                 <ExcelColumn label="Conductor" value="nombre_conductor" />
//                                                 <ExcelColumn label="Unidad" value="unidad"/>
//                                                 <ExcelColumn label="Pasajeros" value="cant_pasajeros"/>
//                                                 <ExcelColumn label="Velocidad" value="velocidad"/>
//                                                 <ExcelColumn label="Ruta" value="ruta"/>
//                                                 <ExcelColumn label="Placa" value="placa"/>
//                                                 <ExcelColumn label="Hora inicio" value="hora_i"/>
//                                                 <ExcelColumn label="Hora Finaliza" value="hora_f"/>
//                                             </ExcelSheet>
//                                         </ExcelFile>
//                                     </div>
//                                     <div className="col-lg-6 col-sm-6 col-md-6" style={{flexDirection: 'column'}}>
//                                         <div className="form-group col-lg-6 col-sm-6 col-md-6" style={{marginBottom: 20}}>
//                                             <label htmlFor="estado">Tipo Vehiculo</label>
//                                             <select ref={select => { this.type = select; }} onChange={(event) =>  this.filterData(event)} className="form-control">
//                                                 <option value="0">Todos</option>
//                                                 {this.state.tipoV.map((snap, index) => {
//                                                     return (
//                                                         <option key={'opcion' + index} value={snap.tipo}>{snap.tipo}</option>
//                                                     )
//                                                 })}
//                                             </select>
//                                         </div>
//                                     </div>
//                             </div>
//                             <br/>
//                             <BootstrapTable data={ this.state.data }
//                                 ref='table'			 
//                                 pagination={ true }
//                                 search={ false }
//                                 hover
//                             >
//                                 <TableHeaderColumn dataField='nombre_conductor' isKey={true} dataSort={true} >Conductor</TableHeaderColumn>
//                                 <TableHeaderColumn dataField='unidad'  dataSort={true}  >Unidad</TableHeaderColumn>
//                                 <TableHeaderColumn dataField='cant_pasajeros' >Pasajeros</TableHeaderColumn>
//                                 <TableHeaderColumn dataField='velocidad' >Velocidad</TableHeaderColumn>
//                                 <TableHeaderColumn dataField='ruta' >Rutas</TableHeaderColumn>
//                                 <TableHeaderColumn dataField='placa' >Placa</TableHeaderColumn>
//                                 <TableHeaderColumn dataField='hora_i' >Hora Inicio</TableHeaderColumn>
//                                 <TableHeaderColumn dataField='hora_f' >Hora Finaliza</TableHeaderColumn>
                                    
//                         </BootstrapTable>
//                         </form>
//                     </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     }
// }

// export default ReporteAsignacionViajes;



// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteAsignacionViajes.js